import ApprovalTable from "../../components/react-table/order-maintenance";

function ApprovalsOrdenesCompra() {
  return (
    <div>
      <ApprovalTable contextmenu="aprueba" />
    </div>
  );
}

export default ApprovalsOrdenesCompra;
